// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/router";

import "../static/css/reset.css";

import "./request/api2019";

import "../static/front/front.css";

import vueAwsomeSwiper from "vue-awesome-swiper"; // Vue划屏组件
import "swiper/dist/css/swiper.min.css";

import store from "./store/store.js"; // 引入store

import Meta from "vue-meta-info";

import VueWechatitle from "vue-wechat-title";

import {
  // Vant组件单独引用
  Search,
  Form,
  Cell,
  CellGroup,
  Picker,
  Field,
  Popup,
  Loading,
  Dialog,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Button,
  Area,
  Toast,
  Overlay,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Uploader,
  List,
  Swipe,
  SwipeItem,
  Lazyload,
  Tab,
  Tabs,
  Cascader,
  ActionSheet,
  TreeSelect,
} from "vant";
import "../static/css/resetSCRM.css";

import VueClipboard from "vue-clipboard2";

// import wx from 'weixin-js-sdk'//Vue微信JS-SDK
// global.wx = wx

import wx from "../static/js/weixin/weixin_sdk1.4.0.js";

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import Carousel3d from "vue-carousel-3d";
Vue.use(Carousel3d);

Vue.use(router);
Vue.use(vueAwsomeSwiper); // 引用metainfo插件用于TDK的SEO优化
Vue.use(Meta); // vue微信自定义title插件
Vue.use(VueWechatitle);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Form);
Vue.use(Icon);
Vue.use(List);
Vue.use(NavBar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Overlay);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cascader);
Vue.use(Area);
Vue.use(Checkbox).use(CheckboxGroup).use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader); // 点击复制功能插件
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard); // 微信原生sdk
Vue.use(wx);
Vue.use(Viewer);
Vue.use(Search);
Vue.use(ActionSheet);
Vue.use(TreeSelect);
Viewer.setDefaults({
  Options: {
    button: true,
    title: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});

Vue.config.productionTip = false;

// 放大缩小
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
// 详细配置
Vue.use(preview, {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: true, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: true, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: false, //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
});
//放大缩小结束
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

Array.prototype.indexOf = function (val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
export function getRandomArrayElements(arr, count) {
  var shuffled = arr.slice(0);
  var i = arr.length;
  var min = i - count;
  var temp;
  var index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
}
Vue.prototype.getRandomArrayElements = getRandomArrayElements;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
  },
  template: "<App/>",
});
